import { sectionName } from '../db/sections';
import type { Room, Section } from '../db/schema';

/** A container's address. The panel opens as a segment underneath it. */
export function sectionPath(roomId: string, sectionId: string | undefined): string {
  return sectionId === undefined ? `/room/${roomId}` : `/room/${roomId}/s/${sectionId}`;
}

/**
 * Where a deleted section's contents will land, named for the confirmation.
 *
 * It has to come from the section being deleted rather than from where you're
 * standing: you can delete the one you're in, or one of its children, and
 * those have different parents.
 */
export function parentNameOf(
  section: Section,
  room: Room,
  path: readonly Section[],
): string {
  if (section.parentId === undefined) return room.name;
  const parent = path.find((each) => each.id === section.parentId);
  return parent === undefined ? room.name : sectionName(parent);
}
